import Vue from 'vue';
import App from './App.vue';
import Comment from './Comment';
import Message from './Message';
/* global $ */
Vue.config.productionTip = false;
if ($('.newseditor').length > 0) { // eslint-disable-line
    $('.newseditor').each(function () { // eslint-disable-line
        new Vue({
            render: h => h(App)
        }).$mount(this);
    });
}

if ($('.commenteditor').length > 0) { // eslint-disable-line
    $('.commenteditor').each(function () { // eslint-disable-line
        new Vue({
            render: h => h(Comment)
        }).$mount(this);
    });
}

if ($('.messageeditor').length > 0) { // eslint-disable-line
    $('.messageeditor').each(function () { // eslint-disable-line
        new Vue({
            render: h => h(Message)
        }).$mount(this);
    });
}

function openNewsChange (e) {
    e.preventDefault();
    let _this = $(this);
    let newsID = _this.attr('data-id');
    let _modal = $('#news-change-modal');
    let _changeContainer = $('#newschange-main');
    _changeContainer.attr('data-id', newsID);
    new Vue({
        render: h => h(App)
    }).$mount('#newschange');
    document.body.classList.add('stop-scrolling');
    _modal.addClass('open');
    return false;
}

$(document.body).on('click', '[data-news-change="true"]', openNewsChange);
$(document.body).on('click', '#close-news-change', function () {
    let _modal = $('#news-change-modal');
    let _modalBody = $('#modal-body-news');
    document.body.classList.remove('stop-scrolling');
    _modal.removeClass('open');
    _modalBody.html('<div  id="newschange-main" class="newschange" data-id=""><div id="newschange"></div></div>');
});

function openNewsfeedTeilen (e) {
    e.preventDefault();
    let _this = $(this);
    let link = _this.attr('data-link');

    let _modal = $('#intern-teilen-newsfeed');
    let _changeContainer = $('#newsfeed-teilen');
    _changeContainer.attr('data-link', link);
    let originalid = _this.attr('data-original-id');
    if (typeof originalid !== 'undefined') {
        _changeContainer.attr('data-original-id', originalid);
    }
    new Vue({
        render: h => h(App)
    }).$mount('#newsfeed-teilen-inner');
    document.body.classList.add('stop-scrolling');
    _modal.addClass('open');
    return false;
}

$(document.body).on('click', '[data-newsfeed-teilen]', openNewsfeedTeilen);

$(document.body).on('click', '#close-newsfeed-teilen', function () {
    let _modal = $('#intern-teilen-newsfeed');
    let _modalBody = $('#modal-body-newsfeed-teilen');
    document.body.classList.remove('stop-scrolling');
    _modal.removeClass('open');
    _modalBody.html(' <div  id="newsfeed-teilen" class="newsfeed-teilen" data-link="" data-original-id=""><div id="newsfeed-teilen-inner"></div></div>');
});

function openNewsfeedChronik (e) {
    e.preventDefault();
    let _this = $(this);
    let link = _this.attr('data-link');
    let _modal = $('#intern-teilen-news');
    let _changeContainer = $('#chronik-teilen');
    _changeContainer.attr('data-link', link);

    let originalid = _this.attr('data-original-id');
    if (typeof originalid !== 'undefined') {
        _changeContainer.attr('data-original-id', originalid);
    }

    $('#teilen-message').hide();
    $('#teilen-chronik').show();
    $('#teilen-content').hide();
    new Vue({
        render: h => h(App)
    }).$mount('#chronik-teilen-inner');
    document.body.classList.add('stop-scrolling');
    _modal.addClass('open');

    return false;
}

$(document.body).on('click', '[data-chronik-teilen]', openNewsfeedChronik);

$(document.body).on('click', '#close-chronik-teilen', function () {
    let _modal = $('#intern-teilen-news');
    let _modalBody = $('#modal-body-chronik-teilen');
    document.body.classList.remove('stop-scrolling');
    _modal.removeClass('open');
    _modalBody.html('<div  id="chronik-teilen" class="chronik-teilen" data-link="" data-original-id=""><div id="chronik-teilen-inner"></div></div>');
});


$(document.body).on('click', '#close-comment-change', function () {
    let _modal = $('#change-comment-modal');
    let _modalBody = $('#modal-body-comment');
    document.body.classList.remove('stop-scrolling');
    _modal.removeClass('open');
    _modalBody.html('<div class="form-item width-100 emoji-picker-container" style="position: relative"\n' +
      '                     id="change-comment-main" data-comment-editor\n' +
      '                     data-news-id=""\n' +
      '                     data-comment-id=""\n' +
      '                     data-comment-main="">\n' +
      '                    <div id="changecomment"></div>\n' +
      '                </div>');
});

$(document.body).on('click', '[data-news-comment-new]', function () {
    let _this = $(this);
    let _parent = _this.closest('.comment');
    let _editors = _parent.find('.comment-editor');
    let _insters = _parent.find('[data-comment-editor]');
    if (_editors.length > 0) {
        let _editor = $(_editors[0]);
        let mainId = $(_insters[0]).attr('data-comment-main');
        $(_insters[0]).html('<div id="commenteditor-' + mainId + '" class="commenteditor"></div>');
        _editor.addClass('show');
        new Vue({
            render: h => h(Comment)
        }).$mount('#commenteditor-' + mainId);

    }

});

function changeCommentOpen (e) {
    e.preventDefault();
    let _this = $(this);
    let commentID = _this.attr('data-comment-edit');
    let _modal = $('#change-comment-modal');
    let _changeContainer = $('#change-comment-main');
    _changeContainer.attr('data-comment-id', commentID);
    new Vue({
        render: h => h(Comment)
    }).$mount('#changecomment');

    _modal.addClass('open');
    return false;
}

$(document.body).on('click', '[data-comment-edit]', changeCommentOpen);
function scrollProducts () {
    var end = $('#footer').offset().top;
    var viewEnd = $(window).scrollTop() + $(window).height();
    var distance = end - viewEnd;

    // when we're almost at the bottom
    if (distance < 2000) {
        // unbind to prevent excessive firing
        $(window).off('scroll', scrollProducts);
        let _page = $('#newsfeedpage');
        let _listing = $('#news-listing');
        let page = parseInt(_page.val());
        let modus = 'loadNewsPage';
        if (typeof _listing.attr('data-modus') !== 'undefined' && _listing.attr('data-modus') !== '') {
            modus = _listing.attr('data-modus');
        }
        $.ajax({
            url: 'api-newsfeed.php',
            type: 'POST',
            dataType: 'json',
            data: {
                'modus': modus,
                'page': page,
                'hash': _listing.attr('data-hash')
            },
            success: function (data) {
                $('#news-listing').append(data.html);
                $('.commenteditor').each(function () { // eslint-disable-line
                    new Vue({
                        render: h => h(Comment)
                    }).$mount(this);
                });
                _page.val(page + 1);
                if (parseInt($('#newsfeedsites').val()) >= (page + 1)) {
                    $(window).on('scroll', scrollProducts);
                }
            }
        });
    }
}

if ($('#newsfeedpage').length > 0) {
    $(window).on('scroll', scrollProducts);
}
